import React from 'react';
import {
    Button,
    DialogActions,
    DialogTitle,
    DialogContent,
    TextField,
    withStyles,
    Paper,
    Grid,
    Divider,
    Tooltip,
    Typography,
    IconButton,
    Tabs,
    Tab,
    ListItemText,
    List,
    InputLabel,
} from 'material-ui';
import SimpleEditor from '../../../../components/editor/simple_editor';
import AddIcon from 'material-ui-icons/AddCircle';
import RemoveIcon from 'material-ui-icons/Cancel';
import {styles} from '../../style/staff_section';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import SortableItem from '../../../../components/sortable/sortable_item';
import {TabContainer} from '../../../../components/tab/tab_container';

class FaqsSectionEdit extends React.Component {
    state = {
        valueTab: 0,
        selectedFaqs: [],
    };

    onSortSelectedFaqs = (selectedFaqs) => {
        this.setState({
            selectedFaqs: selectedFaqs,
        });
        this.props.onSelectedFaqsSort(selectedFaqs);
    };

    handleTabChange = (event, value) => {
        this.setState({
            valueTab: value,
        });
    };

    render() {
        let {
            classes,
            pageId,
            siteId,
            onHandleSubmit,
            onHandleClose,
            faqs,
            title,
            body,
            onSearchFaqs,
            searchCriteria,
            addFaqsToSite,
            selectedFaqs,
            removeFaqsForSite,
            loading,
            onUpdateTitleField,
            onUpdateBodyField,
        } = this.props;

        let {valueTab} = this.state;

        let touched = searchCriteria !== '';

        let filteredFaqs = faqs.filter(
            (faq) =>
                selectedFaqs.filter((selected) => faq.id === selected.id)
                    .length === 0
        );

        selectedFaqs = selectedFaqs ? selectedFaqs : [];

        let listSelectedFaqs = selectedFaqs.map((faq, i) => {
            return (
                <SortableItem
                    key={i}
                    sortId={i}
                    items={selectedFaqs}
                    onSortItems={this.onSortSelectedFaqs}
                    className={classes.faqsOrderItems}
                >
                    <ListItemText secondary={'FAQ: ' + faq.title} />
                </SortableItem>
            );
        });

        let showSelectedFaqs = (
            <Paper className={classes.faqsSelectedResults}>
                <span>
                    <Typography
                        color="primary"
                        className={classes.faqsSearchResultsItems}
                    >
                        Selected faqs
                    </Typography>
                    <Divider />
                </span>
                {selectedFaqs.map((faq) => {
                    let faqTypeName = faq.faq_type_name
                        ? faq.faq_type_name
                        : faq.type_name;
                    return (
                        <Grid container key={faq.id} spacing={0}>
                            <Grid
                                item
                                xs={10}
                                className={classes.faqsSearchResultsItems}
                            >
                                <Typography
                                    className={classes.headingFaqSearch}
                                >
                                    Title: {faq.title}
                                </Typography>
                                <Typography
                                    className={classes.headingFaqSearch}
                                >
                                    Type: {faqTypeName}
                                </Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <span className={classes.searchFaqActionBtn}>
                                    <Tooltip title="Remove Faq from Website">
                                        <IconButton
                                            className="smallIconButton deleteColor"
                                            onClick={(e) =>
                                                removeFaqsForSite(faq.id)
                                            }
                                        >
                                            <RemoveIcon />
                                        </IconButton>
                                    </Tooltip>
                                </span>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                        </Grid>
                    );
                })}
            </Paper>
        );

        return (
            <EditDialog
                open={this.props.open}
                classes={{
                    paper: classes.paper,
                    fullWidth: classes.fullWidth,
                }}
            >
                <DialogTitle>Edit Faqs Section</DialogTitle>
                <DialogContent className={classes.root}>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="title"
                        label="Title"
                        onChange={(event) => {
                            onUpdateTitleField(event.target.value);
                        }}
                        fullWidth
                        value={title || ''}
                    />
                    <InputLabel className="simpleEditorLabelPages">
                        Body
                    </InputLabel>
                    <SimpleEditor
                        initialValue={body}
                        onChange={(htmlBody) => {
                            onUpdateBodyField(htmlBody);
                        }}
                    />
                    <TextField
                        fullWidth
                        label="Search Faqs (by title or content)"
                        value={searchCriteria}
                        onChange={(ev) => {
                            onSearchFaqs(ev.target.value, pageId, siteId);
                        }}
                        className={classes.searchFaqs}
                    />
                    {loading && touched && (
                        <Grid
                            container
                            justify="center"
                            className={classes.loadingText}
                        >
                            Loading...
                        </Grid>
                    )}
                    <Tabs
                        value={valueTab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleTabChange}
                    >
                        <Tab value={0} label="Select Faqs" />
                        {selectedFaqs.length > 1 && (
                            <Tab value={1} label="Change Faqs Order" />
                        )}
                    </Tabs>
                    {valueTab === 0 && (
                        <span>
                            {selectedFaqs.length === 0 && !touched && (
                                <Typography className={classes.noAvailableFaqs}>
                                    No faqs found!
                                </Typography>
                            )}
                            {faqs.length === 0 &&
                                touched &&
                                selectedFaqs.length === 0 && (
                                    <Typography
                                        className={classes.noAvailableFaqs}
                                    >
                                        No faqs found!
                                    </Typography>
                                )}
                            {selectedFaqs.length > 0 && !touched && (
                                <Grid item xs={12}>
                                    {showSelectedFaqs}
                                </Grid>
                            )}
                            {faqs.length > 0 && touched && (
                                <Grid container spacing={0}>
                                    <Grid item xs={12} sm={6}>
                                        <Paper
                                            className={
                                                classes.faqsSearchResults
                                            }
                                        >
                                            <Grid item xs={12}>
                                                {faqs.length === 0 &&
                                                searchCriteria !== '' ? (
                                                    <Grid
                                                        container
                                                        justify="center"
                                                        className={
                                                            classes.loadingText
                                                        }
                                                    >
                                                        Loading...
                                                    </Grid>
                                                ) : (
                                                    ''
                                                )}
                                                {faqs.length !== 0 &&
                                                searchCriteria !== '' ? (
                                                    <span>
                                                        <Grid
                                                            container
                                                            spacing={0}
                                                            className={
                                                                classes.faqsSearchResultsItems
                                                            }
                                                        >
                                                            <Grid item md={6}>
                                                                <Typography
                                                                    className={
                                                                        classes.headingFaqsSearch
                                                                    }
                                                                >
                                                                    <strong>
                                                                        Faq
                                                                        Title
                                                                    </strong>
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item md={5}>
                                                                <Typography
                                                                    className={
                                                                        classes.headingFaqsSearch
                                                                    }
                                                                >
                                                                    <strong>
                                                                        Faq Type
                                                                    </strong>
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item md={1}>
                                                                <Typography
                                                                    className={
                                                                        classes.headingFaqsSearch
                                                                    }
                                                                >
                                                                    <strong>
                                                                        Action
                                                                    </strong>
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <Divider />
                                                    </span>
                                                ) : (
                                                    ''
                                                )}
                                                {filteredFaqs.map((faq) => (
                                                    <Grid item key={faq.id}>
                                                        <Grid
                                                            container
                                                            spacing={0}
                                                            className={
                                                                classes.faqsSearchResultsItems
                                                            }
                                                        >
                                                            <Grid item md={6}>
                                                                <Typography
                                                                    className={
                                                                        classes.headingFaqsSearch
                                                                    }
                                                                >
                                                                    {faq.title}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item md={5}>
                                                                <Typography
                                                                    className={
                                                                        classes.headingFaqsSearch
                                                                    }
                                                                >
                                                                    {
                                                                        faq.faq_type_name
                                                                    }
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item md={1}>
                                                                <Tooltip title="Add Faq to FAQs page on the Website">
                                                                    <IconButton
                                                                        className="smallIconButton editColor"
                                                                        onClick={(
                                                                            e
                                                                        ) =>
                                                                            addFaqsToSite(
                                                                                faq
                                                                            )
                                                                        }
                                                                    >
                                                                        <AddIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Grid>
                                                        </Grid>
                                                        <Divider />
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        {showSelectedFaqs}
                                    </Grid>
                                </Grid>
                            )}
                        </span>
                    )}
                    {valueTab === 1 && (
                        <TabContainer>
                            <List component="nav">
                                <Typography
                                    className={classes.faqsOrderTitle}
                                    color="primary"
                                >
                                    Click on each item to drag and drop in the
                                    desired order
                                </Typography>
                                <Divider />
                                {listSelectedFaqs}
                            </List>
                        </TabContainer>
                    )}
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleClose(ev)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleSubmit(ev)}
                        color="primary"
                    >
                        Done
                    </Button>
                </DialogActions>
            </EditDialog>
        );
    }
}

export default withStyles(styles)(FaqsSectionEdit);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/faqs_section_edit.js